
import { useCallback } from 'react';
import posthog, { trackEvent } from '@/integrations/posthog/client';

export const useAnalytics = () => {
  const trackPageView = useCallback((name?: string, properties?: Record<string, any>) => {
    posthog.capture('$pageview', { 
      ...properties,
      page_name: name
    });
  }, []);

  const trackEventWithProps = useCallback((name: string, properties?: Record<string, any>) => {
    trackEvent(name, properties);
  }, []);

  return {
    trackPageView,
    trackEvent: trackEventWithProps
  };
};
